import { render, staticRenderFns } from "./GroupCalendarBus.vue?vue&type=template&id=24d2cd0e"
import script from "./GroupCalendarBus.vue?vue&type=script&lang=js"
export * from "./GroupCalendarBus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports